import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './aplicacion.css'

const Aplicacion = (props) => {
  return (
    <div className="aplicacion-container1">
      <Helmet>
        <title>
          Aplicacion - GESVET – App para digitalizar el trabajo veterinario en
          campo
        </title>
        <meta
          name="description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:title"
          content="Aplicacion - GESVET – App para digitalizar el trabajo veterinario en campo"
        />
        <meta
          property="og:description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/c5d5ed29-b3ec-4d24-824a-945896b13c65/a683aef5-7460-454d-aed7-588f9c14e5a7?org_if_sml=1&amp;force_format=original"
        />
        <link rel="canonical" href="https://www.gesvet.com.ar/aplicacion" />
        <meta
          property="og:url"
          content="https://www.gesvet.com.ar/aplicacion"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="app-page-wrapper">
        <div className="soporte-hero-section hero-section">
          <div className="soporte-hero-bg hero-bg">
            <img
              alt="image"
              src="/images/gevet-vacas2-1500h.jpeg"
              className="aplicacion-image1 hero-video"
            />
            <div className="soporte-hero-overlay1"></div>
          </div>
          <div className="hero-content-wrapper soporte-hero-content-wrapper">
            <div className="hero-main-info">
              <span className="hero-badge soporte-hero-badge">
                Tecnología para Veterinarios
              </span>
              <h1 className="soporte-hero-title1 hero-title">
                Digitaliza tu trabajo en la manga
              </h1>
              <p className="soporte-hero-subtitle hero-subtitle">
                La herramienta definitiva diseñada por veterinarios para
                optimizar la recolección de datos, el análisis en tiempo real y
                la gestión ganadera profesional.
              </p>
              <div className="hero-features-bar">
                <div className="feature-tag">
                  <div className="tag-icon">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057m-2.926 2.753A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78M2 2l20 20"></path>
                    </svg>
                  </div>
                  <span>Trabajo Offline</span>
                </div>
                <div className="feature-tag">
                  <div className="tag-icon">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"></path>
                    </svg>
                  </div>
                  <span>Respaldo en la Nube</span>
                </div>
              </div>
            </div>
            <div className="hero-app-nav">
              <div className="nav-grid">
                <div className="active nav-card">
                  <div className="soporte-card-icon">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                    </svg>
                  </div>
                  <div className="card-text">
                    <span className="card-title soporte-card-title">Home</span>
                    <span className="card-desc">Acceso rápido y versión</span>
                  </div>
                </div>
                <div className="nav-card">
                  <div className="soporte-card-icon">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="3" rx="1" width="7" height="9"></rect>
                      <rect x="14" y="3" rx="1" width="7" height="5"></rect>
                      <rect x="14" y="12" rx="1" width="7" height="9"></rect>
                      <rect x="3" y="16" rx="1" width="7" height="5"></rect>
                    </svg>
                  </div>
                  <div className="card-text">
                    <span className="card-title soporte-card-title">
                      Dashboard
                    </span>
                    <span className="card-desc">Estadísticas y gráficos</span>
                  </div>
                </div>
                <div className="nav-card">
                  <div className="soporte-card-icon">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 3h18v18H3z"></path>
                      <path d="M9 3v18"></path>
                      <path d="M3 9h18"></path>
                      <path d="M3 15h18"></path>
                    </svg>
                  </div>
                  <div className="card-text">
                    <span className="card-title soporte-card-title">
                      Establecimientos
                    </span>
                    <span className="card-desc">
                      Gestión integral de campos
                    </span>
                  </div>
                </div>
                <div className="nav-card">
                  <div className="soporte-card-icon">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                      <circle r="3" cx="12" cy="12"></circle>
                    </svg>
                  </div>
                  <div className="card-text">
                    <span className="card-title soporte-card-title">
                      Ajustes
                    </span>
                    <span className="card-desc">Configuración y Backup</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="establishments-section">
          <div className="section-header-group">
            <h2 className="soporte-section-title section-title">
              Gestión de Establecimientos
            </h2>
            <p className="section-content">
              Administra todos tus campos desde un solo lugar. Agrega nuevos
              establecimientos, edita información existente y accede a los
              servicios vinculados a cada unidad productiva.
            </p>
          </div>
          <div className="est-grid">
            <div className="est-feature-card">
              <div className="aplicacion-thq-thq-est-visual-elm-elm est-visual">
                <div className="est-overlay-badge">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v8m-4-4h8"></path>
                  </svg>
                  <span>
                    {' '}
                    Alta Ilimitada
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
                <video
                  src="/videos/manga%20gesvet%20(2).mp4"
                  loop="true"
                  muted="true"
                  poster="https://play.teleporthq.io/static/svg/videoposter.svg"
                  autoPlay="true"
                  playsInline="true"
                  className="aplicacion-video"
                ></video>
              </div>
              <div className="aplicacion-thq-thq-est-info-elm-elm est-info">
                <h3 className="aplicacion-thq-thq-card-title-elm-elm5 card-title soporte-card-title">
                  Control Total
                </h3>
                <ul className="est-list">
                  <li className="est-item">
                    <span className="bullet"></span>
                    <span>
                      {' '}
                      Registro de Propietario, Ciudad y Provincia
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li className="est-item">
                    <span className="bullet"></span>
                    <span>
                      {' '}
                      Menú de acciones rápidas (Editar/Borrar)
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li className="est-item">
                    <span className="bullet"></span>
                    <span> Buscador inteligente por caravanas</span>
                  </li>
                  <li className="est-item">
                    <span className="bullet"></span>
                    <span>
                      {' '}
                      Historial completo de servicios
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li className="est-item">
                    <span className="bullet"></span>
                    <span>
                      {' '}
                      Reporte de establecimiento integral con filtros por fecha
                      y tipo de servicio
                    </span>
                  </li>
                  <li className="est-item">
                    <span className="bullet"></span>
                    <span>
                      {' '}
                      Filtro de servicio por tipo de servicio y año de servicio
                      para agilizar la búsqueda datos históricos
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="services-main-container">
          <div className="centered section-header-group">
            <h2 className="soporte-section-title section-title">
              Servicios Profesionales
            </h2>
            <p className="section-content">
              GESVET cubre todas las necesidades operativas del veterinario de
              campo con formularios específicos y flujos de trabajo optimizados.
            </p>
          </div>
          <div className="services-bento">
            <div className="tacto service-bento-item">
              <div className="service-image-box">
                <img
                  alt="image"
                  src="/images/tacto-1500w.jpg"
                  className="aplicacion-image2"
                />
                <div className="service-tag">
                  <span>Tacto Vaca</span>
                </div>
              </div>
              <div className="soporte-service-content">
                <h3 className="card-title soporte-card-title">
                  Tacto y Tacto Vaca Simple
                </h3>
                <p className="section-content">
                  Registro de preñez (Grande/Mediana/Chica), Vacía y CUT.
                  Incluye condición corporal y dentadura.
                </p>
              </div>
            </div>
            <div className="service-bento-item toros">
              <div className="service-image-box">
                <img
                  alt="image"
                  src="/images/toros-1500w.jpg"
                  className="aplicacion-image3"
                />
                <div className="service-tag">
                  <span>Toros</span>
                </div>
              </div>
              <div className="soporte-service-content">
                <h3 className="card-title soporte-card-title">
                  Revisación de Toros
                </h3>
                <p className="section-content">
                  Evaluación de circunferencia escrotal, tono testicular,
                  aplomos y ojos. Clasificación Apto/Rechazo.
                </p>
              </div>
            </div>
            <div className="iatf service-bento-item">
              <div className="service-image-box">
                <img
                  alt="image"
                  src="/images/iatf-1500w.jpg"
                  className="aplicacion-image4"
                />
                <div className="service-tag">
                  <span>IATF</span>
                </div>
              </div>
              <div className="soporte-service-content">
                <h3 className="card-title soporte-card-title">
                  IATF y IATF Simple
                </h3>
                <p className="section-content">
                  Gestión de protocolos, revisación inicial, inseminadores y
                  control de Eco/Tacto post-servicio.
                </p>
              </div>
            </div>
            <div className="preservicio service-bento-item">
              <div className="service-image-box">
                <img
                  src="/images/vacas1-1500w.jpeg"
                  alt="image"
                  className="aplicacion-image5"
                />
                <div className="service-tag">
                  <span>Pre-servicio</span>
                </div>
              </div>
              <div className="soporte-service-content">
                <h3 className="card-title soporte-card-title">
                  Tacto Pre-servicio
                </h3>
                <p className="section-content">
                  Análisis de útero y ovarios para determinar aptitud
                  reproductiva antes del servicio.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="reports-section">
          <div className="reports-container">
            <div className="reports-visual">
              <div className="report-mockup">
                <img
                  alt="image"
                  src="/images/reporte-400w.png"
                  className="aplicacion-image6"
                />
              </div>
            </div>
            <div className="reports-content">
              <h2 className="soporte-section-title section-title">
                Informes Profesionales al Instante
              </h2>
              <p className="section-content">
                Elimina las horas de oficina pasando datos a limpio. Genera
                reportes detallados en segundos y envíalos directamente a tus
                clientes.
              </p>
              <div className="report-types">
                <div className="report-type-item">
                  <div className="report-icon">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <path d="M14 2v6h6"></path>
                      <path d="M16 13H8"></path>
                      <path d="M16 17H8"></path>
                      <path d="M10 9H8"></path>
                    </svg>
                  </div>
                  <div className="report-info">
                    <span className="report-label">Reportes PDF</span>
                    <span className="report-detail">
                      Filtrados por tipo de servicio y rango de fechas. Listos
                      para WhatsApp o Gmail.
                    </span>
                  </div>
                </div>
                <div className="report-type-item">
                  <div className="report-icon">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <path d="M8 13h2v7H8z"></path>
                      <path d="M14 13h2v7h-2z"></path>
                      <path d="M11 13h2v7h-2z"></path>
                      <path d="M8 13h8"></path>
                    </svg>
                  </div>
                  <div className="report-info">
                    <span className="report-label">Exportación Excel</span>
                    <span className="report-detail">
                      Base de datos completa del establecimiento con toda la
                      información técnica cargada.
                    </span>
                  </div>
                </div>
              </div>
              <button className="btn btn-primary btn-lg">
                Descargar App ahora
              </button>
            </div>
          </div>
        </div>
      </section>
      <div className="aplicacion-container2">
        <div className="aplicacion-container3">
          <Script
            html={`<script>
(function(){
  // Manejo de interacción básica para las tarjetas de navegación del Hero
  const navCards = document.querySelectorAll(".nav-card")

  navCards.forEach((card) => {
    card.addEventListener("click", () => {
      // Remover clase activa de todas
      navCards.forEach((c) => c.classList.remove("active"))
      // Agregar a la clickeada
      card.classList.add("active")
    })
  })

  // Animación simple de entrada para los elementos de servicio al hacer scroll
  const observerOptions = {
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  const animatedElements = document.querySelectorAll(".service-bento-item, .est-feature-card")
  animatedElements.forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(30px)"
    el.style.transition = "all 0.6s ease-out"
    observer.observe(el)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer
        text={
          <Fragment>
            <span className="aplicacion-text23">Soporte</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="aplicacion-text24">Aplicacion</span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="aplicacion-text25">Home</span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="aplicacion-text26">Bluetooth</span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="aplicacion-text27">Soporte1</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default Aplicacion
